
import { useState, useRef } from 'react';
import { ReactComponent as ImageScissorsLeft } from '../../../public/images/svg/ImageScissors Left.svg';
import { ReactComponent as ImageScissorsRight } from '../../../public/images/svg/ImageScissors Right.svg';
import './css/CuttingProgress.css';

interface CuttingProgressProps {
    text?: string;
}

export const CuttingProgress: React.FC<CuttingProgressProps> = ({ text }) => {

    const leftScissorsRef = useRef<SVGSVGElement | null>(null);
    const rightScissorsRef = useRef<SVGSVGElement | null>(null);

    return (
        <div className="cutting-progress-container">
            <span className="cutting-progress-text">{text}</span>
            <span className="image-scissors-cut-line" />
            <div className="image-scissors-container">                
                <ImageScissorsLeft id="left-scissor" className="image-scissors" width={16.761} height={32} viewBox="0 0 16.761 32" ref={leftScissorsRef} />
                <ImageScissorsRight id="right-scissor" className="image-scissors" width={16.761} height={32} viewBox="0 0 16.761 32" ref={rightScissorsRef} />
            </div>

        </div>
    );
};
